// 广告相关接口

/**
 * @description [获取pc端首页logo](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/BannerController/getPCTopBanner)
 */
export const getBannerTopPcBanner = () => service.get<Res<Banner.ComBannerWebVO[]>>('/banner/topPcBanner')

/**
 * @description [获取移动端端首页logo](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/BannerController/getMobileTopBanner)
 */
export const getBannerTopMobileBanner = () => service.get<Res<Banner.ComBannerWebVO[]>>('/banner/topMobileBanner')

/**
 * @description [获取pc底部logo](http://192.168.2.230:18192/api/web/swagger-ui/index.html#/BannerController/getPCBottomBanner)
 */
export const getBannerBottomBanner = () => service.get<Res<Banner.ComBannerWebVO>>('/banner/bottomBanner')
